// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDRQ-F6bV-xwcCggSJ_nbB9frdgrAF_s34",
  authDomain: "netflixgpt-6ede5.firebaseapp.com",
  projectId: "netflixgpt-6ede5",
  storageBucket: "netflixgpt-6ede5.firebasestorage.app",
  messagingSenderId: "357576613418",
  appId: "1:357576613418:web:3bd5696159cc70f889ed53",
  measurementId: "G-ZMDTZRBJYT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();
